// Product and Service Data
export const GET_PRODUCT_AND_SERVICE_DATA = 'GET_PRODUCT_AND_SERVICE_DATA';
export const ERROR_GET_PRODUCT_AND_SERVICE_DATA = 'ERROR_GET_PRODUCT_AND_SERVICE_DATA';